import { useEffect, useState } from 'react';
import { resolveHistoryTimezone, historyToday } from '../../../common/historyTimezone';

export default function useHeatmapHistory() {
  const [timezone] = useState(resolveHistoryTimezone);
  const today = historyToday(timezone);
  const [date, setDate] = useState(today);
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    const refresh = () => setRevision(value => value + 1);
    window.addEventListener('layout-values-changed', refresh);
    return () => window.removeEventListener('layout-values-changed', refresh);
  }, []);
  return { date, setDate, today, timezone, revision,
    params: date === today ? {} : { as_of_date: date, timezone } };
}
